// fetch() pro tlačítka Smazat / Obnovit / Nezávadný

import { FlashMessage } from '@components';
import * as Sentry from '@sentry/browser';

export interface ResponseSuccess {
  status: boolean;
}

interface FormChangeStatusCommentProps {
  apiRoute: string;
  requestData: FormData;
  successMessage: string;
}

export const formChangeStatusComment = ({
  apiRoute,
  requestData,
  successMessage,
}: FormChangeStatusCommentProps) => {
  fetch(apiRoute, {
    method: 'POST',
    body: requestData,
  })
    .then((response) => response.json())
    .then(async (data: ResponseSuccess) => {
      if (data.status) {
        // Informovat uživatele
        await FlashMessage({
          msg: successMessage,
          type: 'success',
        });

        // Reloadovat stránku
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        Sentry.captureException('formChangeStatusComment: Operace se nepodařila.');
        throw new Error('Operace se nepodařila.');
      }
    })
    .catch(async () => {
      await FlashMessage({
        msg: 'Operace se nepodařila.',
        type: 'error',
      });
      Sentry.captureException('formChangeStatusComment: Operace se nepodařila.');
    });
};
